import { useState } from "react";
import Document from "../../models/document";
import { getAbsoluteUrl } from "../../api/urls";
import { fetchAuthenticated } from "../../api/utils";
import { warningAlert } from "../utils/messages";

const useDocumentDownload = () => {
  const [downloadingIds, setDownloadingIds] = useState<Set<number>>(new Set());

  const handleDownloadClick = async (downloadDoc: Document) => {
    try {
      if (!downloadDoc || !downloadDoc.id) {
        throw new Error("Documento inválido");
      }

      setDownloadingIds((prev) => new Set(prev).add(downloadDoc.id!));

      const downloadUrl = getAbsoluteUrl(
        `/documents/${downloadDoc.id}/get_document_url/`
      );

      const downloadResponse = await fetchAuthenticated(downloadUrl, {
        method: "GET",
      });

      if (!downloadResponse.ok) {
        throw new Error(
          `Error HTTP ${downloadResponse.status}: ${downloadResponse.statusText}`
        );
      }

      const blob = await downloadResponse.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = downloadDoc.filePath || "documento";

      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error al descargar:", error);
      warningAlert(
        `Error al descargar: ${
          error instanceof Error ? error.message : String(error)
        }`
      );
    } finally {
      setDownloadingIds((prev) => {
        const newSet = new Set(prev);
        newSet.delete(downloadDoc.id!);
        return newSet;
      });
    }
  };

  return {
    downloadingIds,
    handleDownloadClick,
  };
};

export default useDocumentDownload;
